import { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import { Flex, useDisclosure } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";

import { ClaimParams } from "@/api/claimsApi";
import { getHierarchyQueryOption } from "@/api/queryOptions/usersAPIQueryOptions";
import { RelatedCompanyDto } from "@/api/usersApi";
import BranchCompanyButton from "./BranchCompanyButton";
import { BranchCompanyModal } from "./Modal";

type BranchCompanyFilterProps = {
    setClaimsQuery: Dispatch<SetStateAction<ClaimParams>>;
};

const BranchCompanyFilter = ({ setClaimsQuery }: BranchCompanyFilterProps) => {
    const [selectedBranch, setSelectedBranch] = useState<RelatedCompanyDto | null>(null);

    const { data: branchCompanies, isLoading, isError } = useQuery(getHierarchyQueryOption());
    const { open: isBranchModalOpen, onOpen: onOpenBranchModal, onClose: onCloseBranchModal } = useDisclosure();

    const handleCloseBranchModal = useCallback(() => {
        onCloseBranchModal();
    }, [onCloseBranchModal]);

    useEffect(() => {
        if (selectedBranch) {
            setClaimsQuery(prev => ({ ...prev, companyId: selectedBranch.crmId }));

            onCloseBranchModal();
        }
    }, [onCloseBranchModal, selectedBranch, setClaimsQuery]);

    return (
        <Flex flexDir="column" justifyContent="flex-start" alignItems="flex-start" h="fit-content" w="25%">
            {Boolean(branchCompanies?.children?.length) && (
                <BranchCompanyButton
                    selectedBranch={selectedBranch}
                    setSelectedBranch={setSelectedBranch}
                    onOpenBranchModal={onOpenBranchModal}
                />
            )}
            <BranchCompanyModal
                isOpen={isBranchModalOpen}
                onClose={handleCloseBranchModal}
                selectedBranch={selectedBranch}
                setSelectedBranch={setSelectedBranch}
                branchCompanies={branchCompanies?.children ?? []}
                isError={isError}
                isLoading={isLoading}
            />
        </Flex>
    );
};

export default BranchCompanyFilter;
